<template src="./AppHeader.html"></template>

<script>
import { mapState } from "vuex";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import { CalendarBasisEnum, LanguagesEnum } from "@/enums";
import { common } from "@/utilities";
import store from "@/store";

export default {
  name: "app-header",

  components: {
    LottieAnimation,
  },

  computed: {
    ...mapState({
      weather: (state) => state.weatherData.weather,
    }),

    getIcon() {
      // https://openweathermap.org/weather-conditions#How-to-get-icon-URL
      const iconPath = this.weather.icon;
      const iconName = iconPath.substring(
        iconPath.lastIndexOf("/") + 1,
        iconPath.lastIndexOf(".png")
      );
      return `jsons/b${iconName}.json`;
    },
  },

  methods: {
    handleSearchCityDialogOpen() {
      this.$store.commit("setState", { isSearchCityOpen: true });
    },
  },

  filters: {
    year(date) {
      if (store.state.queryParams.sub.xz === CalendarBasisEnum.Gregorian) {
        return new Date(date).getFullYear();
      } else {
        return common.gregorianToJalali(date, "year");
      }
    },

    cityName(city) {
      // Don't use store.getters
      if (typeof city === "object") {
        if (
          store.state.queryParams.sub.xo === LanguagesEnum.fa ||
          store.state.queryParams.sub.xo === LanguagesEnum.ar ||
          store.state.queryParams.sub.xo === LanguagesEnum.ur
        )
          return city.cityFaName ? city.cityFaName : city.cityEnName;

        return city.cityEnName ? city.cityEnName : city.cityFaName;
      }

      return city;
    },
  },
};
</script>
